module.exports = __webpack_public_path__ + "img/vuejs.c0e55022.svg";